<template>
	<section class="hhdealers__results">
		<div class="hhdealers__results__inner">
			<header class="hhdealers__results__header" v-if="this.getActiveFilter() !== ''">
				<h2 class="hhdealers__results__title">{{ this.getMicroCopy().map_copy_results_title }}</h2>
				<p class="hhdealers__results__intro" v-html="this.dealerListHeaderString( this.getActiveFilter() )"></p>
			</header>
			<dealer v-for="( dealer, ind ) in filteredList" :key="ind" :dealer="dealer" />
		</div>
	</section>
</template>
<script>
import Dealer from './Dealer'
import { mapGetters } from 'vuex'
import calculate from '../utils/distance'
export default {
	props: [ 'dealers' ],
	components: {
		'dealer': Dealer
	},
	methods: {
		...mapGetters([
			'getActiveFilter',
			'getSubFilter',
			'getProductGroepen',
			'getSearchLatLng',
			'getSearch',
			'getMicroCopy',
			'getUniqueBrands'
		]),
		hasPro ( id ) {
			const results = this.dealers.filter( ( dealer ) => {
				return dealer.brands.find( ( brand ) => {
					return brand.ID === id && brand.pro === true
				} )
			})
			return results.length > 0 
		},
		dealerListHeaderString( slug ) {
			const brand = this.getUniqueBrands().find( ( brand ) => {
				return brand.slug === slug
			} )
			const productGroepen = this.getProductGroepen().map( ( slug ) => {
				return brand.productGroepen.find( ( productGroep ) => {
					return productGroep.slug === slug
				} ).name
			} )
			let dealerListHeaderString = `
				<p class="hhdealers__results__selection-fb">${ brand.name } ${ this.getSubFilter() ? 'PRO-' : '' }${ this.getMicroCopy().map_copy_results_feedback_1 } ${ productGroepen.length !== 0 ? this.getMicroCopy().map_copy_results_feedback_2 + ' ' + productGroepen.join( ', ' ) : ''}${ this.getSearch() !== '' ? '<br />' + this.getMicroCopy().map_copy_results_feedback_3 + ' ' + this.getSearch() : '' }</p>
			`

			if ( this.hasPro( brand.ID ) && brand.info_page_url ) {
				dealerListHeaderString += `<div class="hhdealers__results__pro-info">${ this.getMicroCopy().map_copy_results_pro_intro }`
				dealerListHeaderString += `<a href="${ brand.info_page_url }" class="hhdealers__result__pro-btn" target="_blank">${ this.getMicroCopy().map_copy_results_pro_btn } ${ brand.name } PRO dealer <i class="fa fa-external-link"></i></i></a></div>`
			}
			return dealerListHeaderString
		}
	},
	created () {
		// console.log(  )
	},
	computed: {
		filteredList () {
			let nrGroepen = this.getProductGroepen().length
			return this.dealers.filter( ( dealer ) => {
				return dealer.brands.find( ( brand ) => {
					return brand.slug === this.getActiveFilter() && 
						( this.getSubFilter() === true ? brand.pro === true : true ) &&
						( nrGroepen > 0 ?  brand.productgroepen && brand.productgroepen.filter( ( groep ) => {
							return this.getProductGroepen().indexOf( groep.slug ) !== -1
						} ).length > 0 : true )
				} )
			} ).filter( ( d ) => {
				if ( ! this.getSearchLatLng() ) {
					return true
				} else {
					const dealerLatLng = { 
						lat: parseFloat( d.latlong.dealer_lat ), 
						lng: parseFloat( d.latlong.dealer_long )
					}
					return calculate( this.getSearchLatLng(), dealerLatLng ) < 25.0	
				}
			} ).sort( ( a, b ) => {
				return a.name <= b.name ? -1 : 1
			} ).sort( ( a, b ) => {
				const latLngA = {
					lat: a.latlong.dealer_lat,
					lng: a.latlong.dealer_long
				}
				const latLngB = {
					lat: b.latlong.dealer_lat,
					lng: b.latlong.dealer_long
				}
				return ( 
					! this.getSearchLatLng() ? 0 :
					( calculate( latLngA, this.getSearchLatLng() ) <= calculate( latLngB, this.getSearchLatLng() ) ?
					-1 : 1
					)
				)
			} )
		}
	}
}
</script>